export default __webpack_public_path__ + "static/media/cover.ee0079bd.gif";